import Service from '@/helpers/service'

export default {
    perMcr(params) {
        return Service().get('McrAvgDuration/per-mcr', {params});
    },
    perCompany(params) {
        return Service().get('McrAvgDuration/per-company', {params});
    },
    perJabatan(params) {
        return Service().get('McrAvgDuration/per-jabatan', {params});
    },
    export(params) {
        return Service().get('McrAvgDuration/export', {params, responseType: 'blob'});
    },
}
